import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/search/page.jsx")